export var DocumentType;
(function (DocumentType) {
    DocumentType["Motion"] = "Motion";
    DocumentType["Brief"] = "Brief";
    DocumentType["Contract"] = "Contract";
    DocumentType["Memo"] = "Memo";
    DocumentType["Discovery"] = "Discovery";
    DocumentType["Correspondence"] = "Correspondence";
    DocumentType["ExpertReport"] = "ExpertReport";
    DocumentType["DueDiligenceChecklist"] = "DueDiligenceChecklist";
    DocumentType["BoardResolution"] = "BoardResolution";
    DocumentType["TermSheet"] = "TermSheet";
})(DocumentType || (DocumentType = {}));
export var ConfidentialityLevel;
(function (ConfidentialityLevel) {
    ConfidentialityLevel["Public"] = "Public";
    ConfidentialityLevel["Confidential"] = "Confidential";
    ConfidentialityLevel["AttorneyClientPrivileged"] = "AttorneyClientPrivileged";
    ConfidentialityLevel["WorkProduct"] = "WorkProduct";
})(ConfidentialityLevel || (ConfidentialityLevel = {}));
export var DocumentVersionStatus;
(function (DocumentVersionStatus) {
    DocumentVersionStatus["Draft"] = "Draft";
    DocumentVersionStatus["Review"] = "Review";
    DocumentVersionStatus["Final"] = "Final";
})(DocumentVersionStatus || (DocumentVersionStatus = {}));
//# sourceMappingURL=document.js.map